import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DebtSolutionsPage from './DebtSolutionsPage.vue';
import MyDebtTab from './components/MyDebtTab.vue';
import MyPlanTab from './components/MyPlanTab.vue';
import LearnMoreTab from './components/LearnMoreTab.vue';
import { RouteNames } from '@/router/routeNames';

export default {
  path: '/debtsolutions',
  component: DashboardLayout,
  children: [
    {
      name: RouteNames.DEBT_SOLUTIONS,
      path: '',
      component: DebtSolutionsPage,
      children: [
        {
          name: RouteNames.MY_DEBT,
          path: 'mydebt',
          component: MyDebtTab,
          params: {
            page: 'mydebt',
          },
          meta: {
            pageTitle: 'My.Debt',
            indexOfRoute: 0,
          },
        },
        {
          name: RouteNames.MY_PLAN,
          path: 'myplan',
          component: MyPlanTab,
          params: {
            page: 'myplan',
          },
          meta: {
            pageTitle: 'My.Plan',
            indexOfRoute: 1,
          },
        },
        {
          name: RouteNames.LEARN_MORE_DEBT,
          path: 'learnmoredebt',
          component: LearnMoreTab,
          meta: {
            pageTitle: 'Learn.More',
            indexOfRoute: 2,
          },
        },
      ],
    },
  ],
};
